import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e44b0fce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collection-detailed-search has-background-contents" }
const _hoisted_2 = { class: "collection-detailed-search-keyword level is-mobile" }
const _hoisted_3 = { class: "collection-detailed-search-body" }
const _hoisted_4 = { class: "collection-detailed-search-queries" }
const _hoisted_5 = { class: "collection-detailed-search-query span2" }
const _hoisted_6 = { class: "collection-detailed-search-query-name" }
const _hoisted_7 = { class: "collection-detailed-search-query-value" }
const _hoisted_8 = { class: "collection-detailed-search-query span2" }
const _hoisted_9 = { class: "collection-detailed-search-query-name" }
const _hoisted_10 = { class: "collection-detailed-search-query-value" }
const _hoisted_11 = { class: "level-left is-mobile" }
const _hoisted_12 = { class: "collection-detailed-search-publication level-left is-mobile" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 〜 ")
const _hoisted_14 = { class: "level-left is-mobile" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "collection-detailed-search-query-value" }, null, -1))
const _hoisted_16 = { class: "collection-detailed-search-query span2" }
const _hoisted_17 = { class: "collection-detailed-search-query-name" }
const _hoisted_18 = { class: "collection-detailed-search-query-value" }
const _hoisted_19 = { class: "collection-detailed-search-query" }
const _hoisted_20 = { class: "collection-detailed-search-query-name" }
const _hoisted_21 = { class: "collection-detailed-search-query-value" }
const _hoisted_22 = { class: "collection-detailed-search-query" }
const _hoisted_23 = { class: "collection-detailed-search-query-name" }
const _hoisted_24 = { class: "collection-detailed-search-query-value" }
const _hoisted_25 = { class: "collection-detailed-search-query" }
const _hoisted_26 = { class: "collection-detailed-search-query-name" }
const _hoisted_27 = { class: "collection-detailed-search-query-value" }
const _hoisted_28 = { class: "collection-detailed-search-query span2" }
const _hoisted_29 = { class: "collection-detailed-search-query-name" }
const _hoisted_30 = { class: "collection-detailed-search-query-value" }
const _hoisted_31 = { class: "collection-detailed-search-query" }
const _hoisted_32 = { class: "collection-detailed-search-query-name" }
const _hoisted_33 = { class: "collection-detailed-search-query-value" }
const _hoisted_34 = { class: "collection-detailed-search-action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_CheckboxList = _resolveComponent("CheckboxList")!
  const _component_AppSelect = _resolveComponent("AppSelect")!
  const _component_InputDate = _resolveComponent("InputDate")!
  const _component_DetailedSearchFooter = _resolveComponent("DetailedSearchFooter")!
  const _component_ModalSheetMobile = _resolveComponent("ModalSheetMobile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"]))
    }, [
      _createVNode(_component_ModalSheetMobile, {
        show: _ctx.showMobile,
        onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('close', false))),
        title: _ctx.$t('label.specifySearchConditions'),
        id: "collection-detailed-search-modal-sheet"
      }, {
        modal: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('form.accessRestrictions')), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_CheckboxList, {
                    items: _ctx.accessRestrictions,
                    modelValue: _ctx.query.accessRestrictions,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query.accessRestrictions) = $event)),
                    id: "collection-detailed-search-access-restriction",
                    class: "collection-detailed-search-access-restriction"
                  }, null, 8, ["items", "modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t(`collectionForm.${_ctx.collectionId}.publicationDate`)), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_AppSelect, {
                      componentId: "collection-detailed-search-eraType",
                      modelValue: _ctx.query.eraType,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query.eraType) = $event)),
                      options: _ctx.eraListLocale
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_InputDate, {
                      "component-id": "collection-detailed-search-publicationFrom",
                      modelValue: _ctx.query.publicationFrom,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.query.publicationFrom) = $event)),
                      key: _ctx.publicationResetKey,
                      lang: _ctx.lang,
                      isAllDate: true,
                      label: _ctx.$t('form.officialGazettes.afterPublicationYear')
                    }, null, 8, ["modelValue", "lang", "label"]),
                    _hoisted_13
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_InputDate, {
                      "component-id": "collection-detailed-search-publicationTo",
                      modelValue: _ctx.query.publicationTo,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.query.publicationTo) = $event)),
                      key: _ctx.publicationResetKey,
                      lang: _ctx.lang,
                      isAllDate: true,
                      label: _ctx.$t('form.officialGazettes.beforePublicationYear')
                    }, null, 8, ["modelValue", "lang", "label"])
                  ])
                ]),
                _hoisted_15
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass([{ 'is-hidden-desktop': !_ctx.state.showAll }, "collection-detailed-search-queries"]),
              id: "detailed-search-queries",
              "aria-live": "polite"
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t(`collectionForm.${_ctx.collectionId}.subjectKanpoList`)), 1),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_CheckboxList, {
                    items: _ctx.subjectKanpo,
                    modelValue: _ctx.query.subjectKanpoList,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.query.subjectKanpoList) = $event)),
                    hasButton: true,
                    id: "collection-detailed-search-access-subjectKanpoList",
                    class: "collection-detailed-search-access-subjectKanpoList"
                  }, null, 8, ["items", "modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t(`collectionForm.${_ctx.collectionId}.volumeSubtitle`)), 1),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_AppInput, {
                    inputId: "collection-detailed-search-volumeSubtitle",
                    modelValue: _ctx.query.volumeSubtitle,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.query.volumeSubtitle) = $event)),
                    label: _ctx.$t(`collectionForm.${_ctx.collectionId}.volumeSubtitle`)
                  }, null, 8, ["modelValue", "label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t(`collectionForm.${_ctx.collectionId}.partTitleKanpo`)), 1),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_AppInput, {
                    inputId: "collection-detailed-search-partTitleKanpo",
                    modelValue: _ctx.query.partTitleKanpo,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.query.partTitleKanpo) = $event)),
                    label: _ctx.$t(`collectionForm.${_ctx.collectionId}.partTitleKanpo`)
                  }, null, 8, ["modelValue", "label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t(`collectionForm.${_ctx.collectionId}.partTitleKanpoNumber`)), 1),
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_AppInput, {
                    inputId: "collection-detailed-search-partTitleKanpoNumber",
                    modelValue: _ctx.query.partTitleKanpoNumber,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.query.partTitleKanpoNumber) = $event)),
                    label: _ctx.$t(`collectionForm.${_ctx.collectionId}.partTitleKanpoNumber`)
                  }, null, 8, ["modelValue", "label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t(`collectionForm.${_ctx.collectionId}.federalRegisterTypeList`)), 1),
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_CheckboxList, {
                    items: _ctx.federalRegisterType,
                    modelValue: _ctx.query.federalRegisterTypeList,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.query.federalRegisterTypeList) = $event)),
                    hasButton: true,
                    id: "collection-detailed-search-access-federalRegisterTypeList",
                    class: "collection-detailed-search-access-federalRegisterTypeList"
                  }, null, 8, ["items", "modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t(`collectionForm.${_ctx.collectionId}.volumeFederalRegister`)), 1),
                _createElementVNode("div", _hoisted_33, [
                  _createVNode(_component_AppSelect, {
                    componentId: "collection-detailed-search-volumeFederalRegisterItemType",
                    modelValue: _ctx.query.volumeFederalRegisterItemType,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.query.volumeFederalRegisterItemType) = $event)),
                    options: _ctx.volumeFederalRegisterItemTypeListLocale
                  }, null, 8, ["modelValue", "options"]),
                  _createVNode(_component_AppInput, {
                    inputId: "collection-detailed-search-volumeFederalRegister",
                    modelValue: _ctx.query.volumeFederalRegister,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.query.volumeFederalRegister) = $event)),
                    label: _ctx.$t(`collectionForm.${_ctx.collectionId}.volumeFederalRegister`)
                  }, null, 8, ["modelValue", "label"])
                ])
              ])
            ], 2),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_DetailedSearchFooter, {
                onClearButtonEvent: _ctx.clearForm,
                modelValue: _ctx.state.showAll,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.showAll) = $event))
              }, null, 8, ["onClearButtonEvent", "modelValue"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_AppInput, {
              "data-cy": "collection-detailed-search-keyword",
              modelValue: _ctx.query.keyword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.keyword) = $event)),
              onSearch: _ctx.search,
              placeholder: _ctx.$t('label.keyword'),
              styled: "is-none",
              class: "item-keyword-search",
              label: _ctx.$t('label.keyword')
            }, null, 8, ["modelValue", "onSearch", "placeholder", "label"]),
            _createVNode(_component_AppButton, {
              "data-cy": "collection-detailed-search-button",
              styled: "is-accent",
              type: "submit",
              label: _ctx.$t('parts.search')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('parts.search')), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _: 1
      }, 8, ["show", "title"])
    ], 32)
  ]))
}